module.exports = __webpack_public_path__ + "vfn-assets/img/app-loader.0e5b583f.gif";